<template>
  <div class="relative h-screen bg-container w-full">
    <div class="absolute inset-0 bg-black opacity-70"></div>
    <div class="h-full flex flex-col items-center justify-center">
      <!-- login component -->
      <div class="z-10 pt-[50px] w-full px-[20px]">
        <!-- Title -->
        <div
          class="text-center text-white"
          style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);"
        >
          <div :class="textStyle" class="text-[32px] h-[64px] pt-[15px]">
            BUYERS PORTAL
          </div>
          <div :class="textStyle" class="text-[#ED7D31] text-[11px]">
            BY MOLDEX REALTY, INC.
          </div>
        </div>

        <!-- BIS Selection -->
        <div v-if="BISSelectionComponent" class="mt-4">
          <div class="text-center opacity1">
            <BISSelection />
          </div>
        </div>

        <!-- Login Form -->
        <div
          v-if="!hide"
          class="text-center bg-white mt-4 rounded-lg shadow-lg p-4"
        >
          <div v-if="!isSignup && logInShow">
            <v-progress-linear
              v-if="progressbar"
              :indeterminate="true"
              color="primary"
            />
            <div class="my-2">
              <div
                class="w-full border rounded-md border-black flex justify-between items-center"
              >
                <input
                  class="bg-white border rounded-md border-black w-full px-4 py-2 outline-none"
                  type="email"
                  v-model="email"
                  placeholder="Email"
                />
              </div>
            </div>
            <div class="my-2 flex w-full justify-start items-center">
              <div
                class="w-full border rounded-md border-black flex justify-between items-center"
              >
                <input
                  class="bg-white border w-full rounded-md px-4 py-2 outline-none"
                  :type="pwVisible ? 'password' : 'text'"
                  v-model="password"
                  placeholder="Password"
                />
                <v-btn @click="openPwVisibility" text>
                  <v-icon v-if="pwVisible">mdi-eye-off</v-icon>
                  <v-icon v-else>mdi-eye</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="flex flex-col items-center space-y-2 mt-4">
              <v-btn
                @click="login"
                dark
                :loading="loadingLogin"
                color="#ED7D31"
                class="w-full text-md"
              >
                Log in
              </v-btn>
              <v-btn
                dark
                :loading="loadingSignup"
                color="#ED7D31"
                class="w-full text-md"
                @click="signup"
              >
                Sign Up
              </v-btn>
              <div class="text-black text-lg mt-2">
                {{ subtitle2 }} Sign up here.
              </div>
            </div>
            <div class="flex justify-between items-center mt-4">
              <div @click="rfp" class="text-left text-black">
                Request for Password
              </div>
              <div class="text-right text-black">
                Privacy Policy
              </div>
            </div>
          </div>

          <!-- Signup Form -->
          <div
            v-else-if="isSignup"
            class="bg-white mt-4 rounded-lg shadow-lg p-4"
          >
            <v-progress-linear
              v-if="progressbar"
              :indeterminate="true"
              color="red"
              height="10px"
            />
            <ContractNumber
              @cancelContractNumber="cancelSignup"
              @submitContractNumber="enterContractNumber"
            />
          </div>

          <!-- OTP Form -->
          <div v-if="otp" class="text-center mt-4">
            <Otp
              @enterOTP="enterOTP"
              :emailFound="emailFound"
              @openBISSelection="openBISSelection"
            />
          </div>

          <!-- Password Form -->
          <div v-if="signupPw" class="text-center mt-4">
            <PassWord @newPwSubmitted="newPwSubmitted" />
          </div>
        </div>

        <!-- Logo -->
        <div class="flex justify-center mt-4">
          <img :src="img" alt="Moldex Logo" class="w-[120px]" />
        </div>
      </div>
    </div>

    <!-- Dialogs -->
    <v-dialog
      v-model="rfp_dialog"
      persistent
      :overlay="false"
      :max-width="maxWidth"
      transition="dialog-transition"
    >
      <div class="bg-white p-2">
        <PasswordRequest />
      </div>
    </v-dialog>

    <v-dialog
      v-model="dialogNoEmail"
      persistent
      :overlay="false"
      :max-width="maxWidth"
      transition="dialog-transition"
    >
      <div
        class="bg-black text-white text-center border-yellow-400 border-2 p-2"
      >
        <div class="flex justify-end">
          <v-icon color="white" @click="cancelSignup">mdi-close</v-icon>
        </div>
        <div>Oops!</div>
        <div class="py-4 text-xs">
          Invalid entry. The contract number or company code encoded does not
          match our records. Please contact us at <br />
          buyersportal-helpdesk@moldex.com.ph <br />
          for assistance.
        </div>
        <div class="py-2">
          <v-btn @click="dialogNoEmail = false">Ok</v-btn>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="dialogVisible" :max-width="maxWidth">
      <div class="bg-white p-4 text-center">
        <div class="text-xl font-bold py-4">Message</div>
        <div class="text-xl py-4">{{ dialogMessage }}</div>
        <div class="py-4 w-full">
          <v-btn class="w-full" dark @click="closeDialog" color="#ED7D31"
            >OK</v-btn
          >
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import PasswordRequest from "./components/PasswordRequest.vue";
import EventBus from "@/EventBus";
import ContractNumber from "./SignUpScreen/components/ContractNumber.vue";
import Otp from "./components/Otp.vue";
import PassWord from "./SignUpScreen/components/PassWord.vue";
import BISSelection from "@/screens/authScreen/SignUpScreen/components/BISSelection.vue";
import axios from "axios";
import SecureStorage from "../../utils/secureStorage.js";

export default {
  data() {
    return {
      isMobile: false,
      dialogVisible: false,
      dialogMessage: "",
      textStyle: "font-bold leading-loose tracking-wide font-noto-sans",
      progressbar: false,
      loadingLogin: false,
      loadingSignup: false,
      indeterminate: false,
      pwVisible: true,
      buyerName: null,
      customerCode: null,
      emailFound: "",
      BISSelectionComponent: false,
      hide: false,
      dialogNoEmail: false,
      signupPw: false,
      logInShow: true,
      otp: false,
      contractNumber: null,
      contractNumberPrefix: null,
      isSignup: false,
      rfp_dialog: false,
      email: "",
      password: "",
      dialog: false,
      subtitle1: "Already have an account? Login here.",
      subtitle2: "Don't have an account yet?",
      subtitlePW:
        "Minimum of 8 characters, at least one capital letter, one small letter, and one number.",
      messageNoEmail: "",
      img: require("@/assets/images/moldex_logo.png"),
    };
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    EventBus.$on("closeSignup", () => {
      this.closeSignup();
    });
    EventBus.$on("Close_RFP_DIALOG", () => {
      this.rfp_dialog = false;
    });
    EventBus.$on("snackbar_rfp", () => {
      this.showDialog("Please check your email about your password request.");
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkIfMobile);
    EventBus.$off("snackbar_rfp");
    EventBus.$off("closeSignup");
    EventBus.$off("Close_RFP_DIALOG");
  },
  computed: {
    maxWidth() {
      return this.$vuetify.breakpoint.smAndDown ? "90%" : "300px";
    },
  },
  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Adjust the breakpoint as needed
    },
    showDialog(message) {
      this.dialogMessage = message;
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.dialogMessage = "";
    },
    openPwVisibility() {
      this.pwVisible = !this.pwVisible;
    },
    openBISSelection() {
      this.otp = false;
      this.hide = true;
      this.BISSelectionComponent = true;
    },
    close_dialog_rfp() {
      this.rfp_dialog = false;
    },
    rfp() {
      this.rfp_dialog = true;
    },
    onProgressBar(show) {
      this.progressbar = show;
    },
    async login() {
      this.onProgressBar(true);
      this.loadingLogin = true;
      if (!this.password || !this.email) {
        this.showDialog("Please complete the text fields.");
        this.onProgressBar(false);
        this.loadingLogin = false;
      } else {
        this.loadingLogin = true;
        let data = {
          email: this.email,
          password: this.password.trim(),
        };
        this.onProgressBar(true);

        try {
          const res = await axios.post("/login/login-client", {
            email: this.email,
            password: this.password.trim(),
          });

          if (res.data.status) {
            // Create auth data object with all required fields
            const authData = {
              authorized: true,
              role: "client",
              token: res.data.token,
              customerCode: res.data.output.user_customer_code,
              email: res.data.output.email_address,
              userId: res.data.output.user_id,
              buyerName: res.data.output.user_buyer_name,
            };

            SecureStorage.setAuthData(authData, false);
            SecureStorage.setItem("buyerName", res.data.output.user_buyer_name);
            const stored = SecureStorage.getItem("auth");

            if (stored && stored.authorized && stored.customerCode) {
              // Check for customerCode
              this.$router.replace({
                name: "Property Selection",
                query: {
                  cc: stored.customerCode, // Use stored customerCode
                },
              });
            } else {
              throw new Error(
                "Storage verification failed - missing customerCode"
              );
            }
          } else {
            this.showDialog(res.data.message);
            this.loadingLogin = false;
            this.onProgressBar(false);
          }
        } catch (error) {
          this.onProgressBar(false);
          this.loadingLogin = false;
          this.showDialog(
            "Unable to connect to the server. Please check your internet connection and try again."
          );
        } finally {
          this.onProgressBar(false);
          this.loading = false;
        }
      }
    },

    closeSignup() {
      this.dialog = false;
    },
    signup() {
      this.isSignup = true;
      this.logInShow = false;
    },
    async enterOTP(otp) {
      if (!otp) {
        this.showDialog("Please enter OTP");
      } else {
        let data = {
          otp: otp,
          contract_number: this.contractNumber.contractNumber,
          email: this.emailFound,
        };
        try {
          const res = await axios.post("/otp/validate", data);
          if (res.data.status) {
            this.otp = false;
            this.logInShow = false;
            this.isSignup = false;
            this.signupPw = true;
          } else {
            this.showDialog(res.data.message);
            this.closeSignup();
          }
        } catch (error) {
          this.showDialog(
            "Unable to connect to the server. Please check your internet connection and try again."
          );
        }
      }
    },
    async newPwSubmitted(password) {
      this.onProgressBar(true);
      let data = {
        email: this.emailFound,
        password: password,
        customerCode: this.customerCode,
        buyerName: this.buyerName,
        userGroup: "client",
      };
      try {
        const res = await axios.post("/password/signup", data);
        if (res.data.status) {
          this.onProgressBar(false);
          this.showDialog(res.data.message);
          this.otp = false;
          this.logInShow = true;
          this.isSignup = false;
          this.signupPw = false;
        } else {
          this.onProgressBar(false);
          this.showDialog(res.data.message);
        }
      } catch (error) {
        this.onProgressBar(false);
        this.showDialog(
          "Unable to connect to the server. Please check your internet connection and try again."
        );
      } finally {
        this.isSignup = false;
        this.logInShow = true;
        this.otp = false;
        this.isSignup = false;
        this.signupPw = false;
      }
    },
    cancelSignup() {
      this.isSignup = false;
      this.logInShow = true;
      this.dialogNoEmail = false;
    },
    async enterContractNumber(contractNumber) {
      if ("contractNumber" in contractNumber) {
        if (contractNumber.contractNumber) {
          if (contractNumber.co_code) {
            let data = {
              contract_number: contractNumber,
            };
            this.onProgressBar(true);
            try {
              const res = await axios.post("/otp/for_signup", data);
              if (res.data.status) {
                this.onProgressBar(false);
                this.showDialog(res.data.message);
                this.otp = true;
                this.contractNumber = contractNumber;
                this.emailFound = res.data.emailFound;
                this.logInShow = false;
                this.isSignup = false;
                this.customerCode = res.data.customerCode;
                this.buyerName = res.data.buyerName;
              } else {
                if (!res.data.exist) {
                  this.dialogNoEmail = true;
                  this.messageNoEmail = res.data.message;
                  this.onProgressBar(false);
                } else {
                  this.onProgressBar(false);
                  this.showDialog(res.data.message);
                }
              }
            } catch (error) {
              this.onProgressBar(false);
              this.showDialog(
                "Unable to connect to the server. Please check your internet connection and try again."
              );
            }
          } else {
            this.showDialog("Please fill in the company code");
            this.onProgressBar(true);
          }
        } else {
          this.showDialog("Please fill in the contract number");
          this.onProgressBar(false);
        }
      } else {
        this.onProgressBar(false);
      }
    },
    noEmail() {
      this.dialogNoEmail = true;
    },
  },
  components: {
    BISSelection,
    PasswordRequest,
    ContractNumber,
    PassWord,
    Otp,
  },
};
</script>

<style scoped>
.bg-container {
  background-image: url("../../assets/images/bg_login.jpg");
  background-size: cover;
  background-position: center;
}

.h-screen {
  height: 100vh;
}

.w-full {
  width: 100%;
}

.text-center {
  text-align: center;
}

.text-white {
  color: white;
}

.text-black {
  color: black;
}
</style>
